import React from 'react';

const Itemeduc = (props) => {
    return (
        <div
            className="item-education"
            onClick={props.handleClick} >
            <div className={`pic ${!props.read ? 'disable' : ''}`}>
                <img src={props.image} />
                <img src="/icons/lock.svg" />
            </div>
            <div className="detaile">
                <h4>{props.title}</h4>
                <div className="status">
                    <span>وضعیت مشاهده : </span>
                    {!props.read ?
                        <span className="disable">خوانده نشده</span>
                        :
                        <span className="seen">خوانده شده</span>
                    }
                </div>
            </div>
        </div>
    );
}

export default Itemeduc;